import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "C:/Users/Simon/Documents/simonrose121.github.io/src/templates/projects-layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...props} components={components} mdxType="MDXLayout">
    <p>{`The Cognitive Function Task implements a method of assessing cognitive function across development designed by`}
      {" "}
      {` `}
      <a href="http://kellytrezise.com/" target="_blank">{`Kelly Trezise`}</a>
      {`. It allows users to create and manage customised assessment tasks and view and export data produced when participants take those tasks. These tasks include settings to generate grids of shapes from a set of criteria.`}</p>
    <p>{`The Cognitive Function Task is split into a Task Management System (TMS) to manage the tasks, and a progressive web app that allows participants to complete tasks, which can be installed on devices or played in the browser. There is also an API used by both applications. Both the TMS and Tasks App were developed using Vue.js, unit tested using Jest and integration tested using Cypress.`}</p>
    <p>{`The project was funded by the`}
      {" "}
      {` `}
      <a href="https://www.lboro.ac.uk/research/cmc/" target="_blank">{` Centre for Mathematical Cognition at Loughborough University `}</a>
      {" "}
      {` and is an ongoing research project.`}</p>
    <p>{`You can play through a sample task`}
      {" "}
      {` `}
      <a href="https://www.cognitivefunctiontask.com/#/?task=tv1_5" target="_blank">{`here`}</a>
      {`.`}</p>

  </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      